import * as systemUtils from "../../../../abstract/controller/utils/systemUtils";
import * as securityUtils from "../../../../abstract/controller/utils/securityUtils"
import { getModelStatus, getProviderLLM } from "./utils/AiUtils";
import RequestBuilderUtil from "./utils/RequestBuilderUtil";

const { safeString, validateFiles, convertFileToAttachment } = RequestBuilderUtil;

export async function buildJSONRequest(message, yaml, history, files = []) {
  const jsonPayload = await createBasePayload(message, history, yaml);

  await processAttachments(files, jsonPayload);

  const body = JSON.stringify(jsonPayload);
  const sha256 = await systemUtils.getSha256(body);

  return {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Amz-Content-Sha256": sha256 },
    body: body,
  };
}

async function createBasePayload(message, history, yaml) {
  const modelStatus = getModelStatus();
  const provider = getProviderLLM();

  const messageStr = typeof message === "string" ? message : safeString(message, "");

  return {
    provider,
    message: messageStr,
    modelStatus: modelStatus,
    model: await systemUtils.encGzipBase64(yaml),
    history: await systemUtils.encGzipBase64(history),
    attachment: [],
    user: securityUtils.getUserUuid()
  };
}

async function processAttachments(files, payload) {
  if (!files || (Array.isArray(files) && files.length === 0)) {
    return;
  }

  const filesArray = Array.isArray(files) ? files : [files];

  const validFiles = validateFiles(filesArray);

  for (const file of validFiles) {
    const attachment = await convertFileToAttachment(file);

    if (attachment) {
      payload.attachment.push(attachment);
    }
  }
}
